import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';

const ItemActionTriangle = observer(function ItemActionTriangle({ item, insertActionId, deleteActionId, tooltipId, onMouseEnter }) {
    if (!item || !item.actionId || !item.productId) return null;

    var isInsert = item.actionId === insertActionId;
    var isDelete = item.actionId === deleteActionId;
    if (!isInsert && !isDelete) return null;

    var className = "table-col-input__notif " + (isInsert ? "table-col-input__notif--insert" : "table-col-input__notif--delete");

    return (
        <div className={className} data-tooltip-id={tooltipId} onMouseEnter={onMouseEnter} data-tooltip-content="" />
    );
});

ItemActionTriangle.propTypes = {
    item: PropTypes.object.isRequired,
    insertActionId: PropTypes.string,
    deleteActionId: PropTypes.string,
    tooltipId: PropTypes.string,
    onMouseEnter: PropTypes.func,
};

export default ItemActionTriangle;
